module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "menunavleftbar ownmenu"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.loggedIn) ? _c('li', {
    staticClass: "dropdown"
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-content"
  }, [_c('li', [_c('h6', [_vm._v("Hello! " + _vm._s(_vm.user))])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])]) : _c('li', [_c('a', {
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("Log In")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/contact"
    }
  }, [_vm._v("Tour Markets")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/create"
    }
  }, [_vm._v("Create A Sellpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#",
      "role": "button"
    }
  }, [_c('i', {
    staticClass: "icon-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/cart"
    }
  }, [_vm._v("My Cart")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/account"
    }
  }, [_vm._v("Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("Log Out")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8185815a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menuleftbar.vue
// module id = 291
// module chunks = 0